














import Vue from "vue";
export default Vue.extend({
  name: "SinglechoiceQuestion",

  props: {
    question: {
      type: Object,
      required: true
    }
  },

  components: {
    SinglechoiceAnswer: () => import("./SinglechoiceAnswer.vue")
  }
});
